
import { useNavigate } from "react-router-dom";
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { AlertScreen } from "../../components/AlertScreen";
import { envVariables, separadorMillares } from "../../../../helpers";
import { useProductosStore } from "../../../../store";
const paginado = Number(envVariables.REACT_APP_PAGINADO);




export const TablaListProductos = ({ data, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const { totalProducto } = useProductosStore();


    const handleOpcionesInfo = (id) => {
        navigate(`/admin/opcion/${id}/producto`)
    }


    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'30%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'15%'}}>CON-IVA</TableCell>
                                <TableCell sx={{width:'20%'}}>CATEGORIA</TableCell>
                                <TableCell sx={{width:'20%'}}>MEDIDA</TableCell>
                                <TableCell sx={{width:'10%'}}>PROVEEDOR</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.map( (pro) => (
                            <TableRow key={ pro.id } onClick={ () => handleOpcionesInfo(pro.id) } sx={{cursor:'pointer'}}>
                                <TableCell >{ pro.nombre }</TableCell>
                                <TableCell>{ `$${separadorMillares(pro.precioCon)}` }</TableCell>
                                <TableCell>{ pro?.categoria ? pro.categoria?.nombre : 'Sin asignar' }</TableCell>
                                <TableCell>{ pro.unidadMedida?.nombre }</TableCell>
                                <TableCell>{ pro.proveedor.length }</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalProducto / paginado)} disabled={Math.ceil(totalProducto / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay productos creados por el momento..."/>
        }
        </>
    )
}
